import { render, staticRenderFns } from "./CalendarAsideHeader.vue?vue&type=template&id=33b5962e&scoped=true&"
import script from "./CalendarAsideHeader.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5962e",
  null
  
)

export default component.exports